module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"list_date":"List Date","dialysis_date":"Dialysis Date","waitlist_summary":"Waitlist Summary"},"fr":{"list_date":"Date de la liste","dialysis_date":"Date de dialyse","waitlist_summary":"Résumé de la liste d\u0027attente"}}')
  delete Component.options._Ctor
}
